import { render, staticRenderFns } from "./commissionIndex.vue?vue&type=template&id=683ccf40&scoped=true&"
import script from "./commissionIndex.vue?vue&type=script&lang=js&"
export * from "./commissionIndex.vue?vue&type=script&lang=js&"
import style0 from "./commissionIndex.vue?vue&type=style&index=0&id=683ccf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ccf40",
  null
  
)

export default component.exports